<!--===========================
=            INBOX            =
============================-->
<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Email Inbox</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Inbox</div>
          <div slot="card-body">
            <!-- Left sidebar -->
            <div class="email-leftbar card">
              <a
                class="btn btn-danger white--text btn-rounded btn-custom btn-block waves-effect waves-light"
              >Compose</a>
              <div class="mail-list m-t-20">
                <a href="#" class="active">
                  Inbox
                  <span class="ml-1">(18)</span>
                </a>
                <a href="#">Starred</a>
                <a href="#">Important</a>
                <a href="#">Draft</a>
                <a href="#">Sent Mail</a>
                <a href="#">Trash</a>
              </div>
              <h6 class="m-t-30">Labels</h6>
              <div class="mail-list m-t-20">
                <a href="#">
                  <span class="mdi mdi-arrow-right-drop-circle text-info float-right"></span>Theme Support
                </a>
                <a href="#">
                  <span class="mdi mdi-arrow-right-drop-circle text-warning float-right"></span>Freelance
                </a>
                <a href="#">
                  <span class="mdi mdi-arrow-right-drop-circle text-primary float-right"></span>Social
                </a>
                <a href="#">
                  <span class="mdi mdi-arrow-right-drop-circle text-danger float-right"></span>Friends
                </a>
                <a href="#">
                  <span class="mdi mdi-arrow-right-drop-circle text-success float-right"></span>Family
                </a>
              </div>
            </div>
            <!-- End Left sidebar -->
            <!-- Right Sidebar -->
            <div class="email-rightbar mb-3">
              <div class="card">
                <div class="btn-toolbar p-3" role="toolbar">
                  <div class="btn-group mr-2 mb-2 mb-sm-0">
                    <button type="button" class="btn btn-primary waves-light waves-effect">
                      <i class="fa fa-inbox"></i>
                    </button>
                    <button type="button" class="btn btn-primary waves-light waves-effect">
                      <i class="fa fa-exclamation-circle"></i>
                    </button>
                    <button type="button" class="btn btn-primary waves-light waves-effect">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                  <div class="btn-group mr-2 mb-2 mb-sm-0">
                    <button
                      type="button"
                      class="btn btn-primary waves-light waves-effect dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fa fa-folder"></i>
                      <i class="mdi mdi-chevron-down ml-1"></i>
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="#">Updates</a>
                      <a class="dropdown-item" href="#">Social</a>
                      <a class="dropdown-item" href="#">Team Manage</a>
                    </div>
                  </div>
                  <div class="btn-group mr-2 mb-2 mb-sm-0">
                    <button
                      type="button"
                      class="btn btn-primary waves-light waves-effect dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fa fa-tag"></i>
                      <i class="mdi mdi-chevron-down ml-1"></i>
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="#">Updates</a>
                      <a class="dropdown-item" href="#">Social</a>
                      <a class="dropdown-item" href="#">Team Manage</a>
                    </div>
                  </div>

                  <div class="btn-group mr-2 mb-2 mb-sm-0">
                    <button
                      type="button"
                      class="btn btn-primary waves-light waves-effect dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      More
                      <i class="mdi mdi-dots-vertical ml-2"></i>
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="#">Mark as Unread</a>
                      <a class="dropdown-item" href="#">Mark as Important</a>
                      <a class="dropdown-item" href="#">Add to Tasks</a>
                      <a class="dropdown-item" href="#">Add Star</a>
                      <a class="dropdown-item" href="#">Mute</a>
                    </div>
                  </div>
                </div>
                <ul class="message-list">
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk19" />
                        <label for="chk19" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Peter, me (3)</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        Hello –
                        <span
                          class="teaser"
                        >Trip home from Colombo has been arranged, then Jenna will come get me from Stockholm. :)</span>
                      </a>
                      <div class="date">Mar 6</div>
                    </div>
                  </li>

                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk20" />
                        <label for="chk20" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">me, Susanna (7)</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        <span class="badge-warning badge mr-2">Freelance</span>Since you asked... and i'm
                        inconceivably bored at the train station –
                        <span
                          class="teaser"
                        >Alright thanks. I'll have to re-book that somehow, i'll get back to you.</span>
                      </a>
                      <div class="date">Mar. 6</div>
                    </div>
                  </li>

                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk6" />
                        <label for="chk6" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Web Support Dennis</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        Re: New mail settings –
                        <span class="teaser">Will you answer him asap?</span>
                      </a>
                      <div class="date">Mar 7</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk7" />
                        <label for="chk7" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">me, Peter (2)</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        <span class="badge-info badge mr-2">Support</span>Off on Thursday -
                        <span
                          class="teaser"
                        >Eff that place, you might as well stay here with us instead! Sent from my iPhone 4 4 mar 2014 at 5:55 pm</span>
                      </a>
                      <div class="date">Mar 4</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk8" />
                        <label for="chk8" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Medium</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        <span class="badge-primary badge mr-2">Social</span>This Week's Top Stories –
                        <span
                          class="teaser"
                        >Our top pick for you on Medium this week The Man Who Destroyed America’s Ego</span>
                      </a>
                      <div class="date">Feb 28</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk9" />
                        <label for="chk9" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Death to Stock</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        Montly High-Res Photos –
                        <span
                          class="teaser"
                        >To create this month's pack, we hosted a party with local musician Jared Mahone here in Columbus, Ohio.</span>
                      </a>
                      <div class="date">Feb 28</div>
                    </div>
                  </li>

                  <li class="unread">
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk3" />
                        <label for="chk3" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Randy, me (5)</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        <span class="badge-success badge mr-2">Family</span>Last pic over my village –
                        <span
                          class="teaser"
                        >Yeah i'd like that! Do you remember the video you showed me of your train ride between Colombo and Kandy? The one with the mountain view? I would love to see that one again!</span>
                      </a>
                      <div class="date">5:01 am</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk4" />
                        <label for="chk4" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Andrew Zimmer</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        Mochila Beta: Subscription Confirmed
                        –
                        <span
                          class="teaser"
                        >You've been confirmed! Welcome to the ruling class of the inbox. For your records, here is a copy of the information you submitted to us...</span>
                      </a>
                      <div class="date">Mar 8</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk5" />
                        <label for="chk5" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Infinity HR</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        Sveriges Hetaste sommarjobb –
                        <span
                          class="teaser"
                        >Hej Nicklas Sandell! Vi vill bjuda in dig till "First tour 2014", ett rekryteringsevent som erbjuder jobb på 16 semesterorter iSverige.</span>
                      </a>
                      <div class="date">Mar 8</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk10" />
                        <label for="chk10" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Revibe</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        <span class="badge-danger badge mr-2">Friends</span>Weekend on Revibe –
                        <span
                          class="teaser"
                        >Today's Friday and we thought maybe you want some music inspiration for the weekend. Here are some trending tracks and playlists we think you should give a listen!</span>
                      </a>
                      <div class="date">Feb 27</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk11" />
                        <label for="chk11" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Erik, me (5)</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        Regarding our meeting –
                        <span
                          class="teaser"
                        >That's great, see you on Thursday!</span>
                      </a>
                      <div class="date">Feb 24</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk12" />
                        <label for="chk12" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">KanbanFlow</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        <span class="badge-primary badge mr-2">Social</span>Task assigned: Clone ARP's website
                        –
                        <span
                          class="teaser"
                        >You have been assigned a task by Alex@Work on the board Web.</span>
                      </a>
                      <div class="date">Feb 24</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk13" />
                        <label for="chk13" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Tobias Berggren</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        Let's go fishing! –
                        <span
                          class="teaser"
                        >Hey, You wanna join me and Fred at the lake tomorrow? It'll be awesome.</span>
                      </a>
                      <div class="date">Feb 23</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk14" />
                        <label for="chk14" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Charukaw, me (7)</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        Hey man –
                        <span class="teaser">Nah man sorry i don't. Should i get it?</span>
                      </a>
                      <div class="date">Feb 23</div>
                    </div>
                  </li>
                  <li class="unread">
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk15" />
                        <label for="chk15" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">me, Peter (5)</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        <span class="badge-info badge mr-2">Support</span>Home again! –
                        <span class="teaser">That's just perfect! See you tomorrow.</span>
                      </a>
                      <div class="date">Feb 21</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk16" />
                        <label for="chk16" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Stack Exchange</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        1 new items in your Stackexchange inbox
                        –
                        <span
                          class="teaser"
                        >The following items were added to your Stack Exchange global inbox since you last checked it.</span>
                      </a>
                      <div class="date">Feb 21</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk17" />
                        <label for="chk17" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">Google Drive Team</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        You can now use your storage in Google
                        Drive –
                        <span
                          class="teaser"
                        >Hey Nicklas Sandell! Thank you for purchasing extra storage space in Google Drive.</span>
                      </a>
                      <div class="date">Feb 20</div>
                    </div>
                  </li>
                  <li>
                    <div class="col-mail col-mail-1">
                      <div class="checkbox-wrapper-mail">
                        <input type="checkbox" id="chk18" />
                        <label for="chk18" class="toggle"></label>
                      </div>
                      <a href="#" class="title body-2">me, Susanna (11)</a>
                      <span class="star-toggle fa fa-star"></span>
                    </div>
                    <div class="col-mail col-mail-2">
                      <a href="#" class="subject">
                        Train/Bus –
                        <span
                          class="teaser"
                        >Yes ok, great! I'm not stuck in Stockholm anymore, we're making progress.</span>
                      </a>
                      <div class="date">Feb 19</div>
                    </div>
                  </li>
                </ul>
              </div>
              <!-- card -->

              <div class="row">
                <div class="col-7">Showing 1 - 20 of 1,524</div>
                <div class="col-5">
                  <div class="btn-group float-right">
                    <button type="button" class="btn btn-sm btn-success waves-effect">
                      <i class="fa fa-chevron-left"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-success waves-effect">
                      <i class="fa fa-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- end Col-9 -->
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import ListFriends from "../../components/Widgets/List/ListFriends.vue";
export default {
  components: {
    BaseCard,
    BaseHeader,
    ListFriends
  },
  data() {
    return {
      items: [
        { title: "Home", icon: "fa fa-pencil" },
        { title: "About", icon: "fa fa-inbox" },
        { title: "Send", icon: "star" },
        { title: "Arquive", icon: "settings_power" }
      ],
      links: [
        { title: "INBOX", icon: "all_inbox" },
        { title: "SENT", icon: "import_export" },
        { title: "TRASH", icon: "restore_from_trash" },
        { title: "IMPORTANT", icon: "star" },
        { title: "STARRED", icon: "mail" }
      ],
      mini: true,
      selected: [2],
      items1: [
        {
          action: "15 min",
          headline: "Brunch this weekend?",
          title: "Ali Connors",
          subtitle:
            "I'll be in your neighborhood doing errands this weekend. Do you want to hang out?"
        },
        {
          action: "2 hr",
          headline: "Summer BBQ",
          title: "me, Scrott, Jennifer",
          subtitle: "Wish I could come, but I'm out of town this weekend."
        },
        {
          action: "6 hr",
          headline: "Oui oui",
          title: "Sandra Adams",
          subtitle: "Do you have Paris recommendations? Have you ever been?"
        },
        {
          action: "12 hr",
          headline: "Birthday gift",
          title: "Trevor Hansen",
          subtitle:
            "Have any ideas about what we should get Heidi for her birthday?"
        },
        {
          action: "18hr",
          headline: "Recipe to try",
          title: "Britta Holt",
          subtitle:
            "We should eat this: Grate, Squash, Corn, and tomatillo Tacos."
        }
      ],
      dropdown_font: [
        { text: "Arial" },
        { text: "Calibri" },
        { text: "Courier" },
        { text: "Verdana" }
      ],
      dropdown_edit: [
        { text: "100%" },
        { text: "75%" },
        { text: "50%" },
        { text: "25%" },
        { text: "0%" }
      ],
      toggle_exclusive: 2,
      toggle_multiple: [1, 2, 3],

      settings: [],
      items2: [
        {
          active: true,
          title: "Jason Oner",
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg"
        },
        {
          active: true,
          title: "Ranee Carlson",
          avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg"
        }
      ]
    };
  }
};
</script>

<style scoped>
.email-leftbar {
  width: 236px;
  float: left;
  padding: 20px;
  border-radius: 5px;
}

.email-rightbar {
  margin-left: 260px;
}

.chat-user-box p.user-title {
  color: #343a40;
  font-weight: 500;
}

.chat-user-box p {
  font-size: 12px;
}

@media (max-width: 767px) {
  .email-leftbar {
    float: none;
    width: 100%;
  }

  .email-rightbar {
    margin: 0;
  }
}

.mail-list a {
  display: block;
  color: #74788d;
  line-height: 24px;
  padding: 8px 5px;
}

.mail-list a.active {
  color: #f46a6a;
  font-weight: 500;
}

.message-list {
  display: block;
  padding-left: 0;
}

.message-list li {
  position: relative;
  display: block;
  height: 50px;
  line-height: 50px;
  cursor: default;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.message-list li a {
  color: #74788d;
}

.message-list li:hover {
  background: #f6f6f6;
  -webkit-transition-duration: 0.05s;
  transition-duration: 0.05s;
}

.message-list li .col-mail {
  float: left;
  font-size: 12px !important;
  position: relative;
}

.message-list li .col-mail-1 {
  width: 320px;
}

.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot,
.message-list li .col-mail-1 .star-toggle {
  display: block;
  float: left;
}

.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}

.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 10px 0 20px;
}

.message-list li .col-mail-1 .star-toggle {
  margin-top: 18px;
  margin-left: 5px;
}

.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 110px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
}

.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 320px;
  right: 0;
  bottom: 0;
}

.message-list li .col-mail-2 .date,
.message-list li .col-mail-2 .subject {
  position: absolute;
  top: 0;
}

.message-list li .col-mail-2 .subject {
  left: 0;
  right: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.message-list li .col-mail-2 .date {
  right: 0;
  width: 170px;
  padding-left: 80px;
}

.message-list li.active,
.message-list li.active:hover {
  -webkit-box-shadow: inset 3px 0 0 #556ee6;
  box-shadow: inset 3px 0 0 #556ee6;
}

.message-list li.unread {
  background-color: #f6f6f6;
  font-weight: 500;
  color: #292d32;
}

.message-list li.unread a {
  color: #292d32;
  font-weight: 500;
}

.message-list .checkbox-wrapper-mail {
  cursor: pointer;
  height: 20px;
  width: 20px;
  position: relative;
  display: inline-block;
  -webkit-box-shadow: inset 0 0 0 1px #ced4da;
  box-shadow: inset 0 0 0 1px #ced4da;
  border-radius: 1px;
}

.message-list .checkbox-wrapper-mail input {
  opacity: 0;
  cursor: pointer;
}

.message-list .checkbox-wrapper-mail input:checked ~ label {
  opacity: 1;
}

.message-list .checkbox-wrapper-mail label {
  position: absolute;
  height: 20px;
  width: 20px;
  left: 0;
  cursor: pointer;
  opacity: 0;
  margin-bottom: 0;
  -webkit-transition-duration: 0.05s;
  transition-duration: 0.05s;
  top: 0;
}

.message-list .checkbox-wrapper-mail label:before {
  content: "\F12C";
  font-family: "Material Design Icons";
  top: 0;
  height: 20px;
  color: #292d32;
  width: 20px;
  position: absolute;
  margin-top: -16px;
  left: 4px;
  font-size: 13px;
}

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 200px;
  }
}

.project-list-table {
  border-collapse: separate;
  border-spacing: 0 12px;
}

.project-list-table tr {
  background-color: #fff;
}

.contact-links a {
  color: #495057;
}

.profile-user-wid {
  margin-top: -26px;
}

.counter-number {
  font-size: 32px;
  font-weight: 600;
  text-align: center;
}

.counter-number span {
  font-size: 16px;
  font-weight: 400;
  display: block;
  padding-top: 5px;
}

.coming-box {
  float: left;
  width: 25%;
}

.hori-timeline .events .event-list {
  text-align: center;
  display: block;
}

.hori-timeline .events .event-list:hover .up-arrow-icon {
  -webkit-animation: fade-up 1.5s infinite linear;
  animation: fade-up 1.5s infinite linear;
}

@media (min-width: 1140px) {
  .hori-timeline .events .event-list {
    width: 24%;
    margin: 0;
    display: inline-block;
  }

  .hori-timeline .events .event-list .event-up-icon {
    position: relative;
  }

  .hori-timeline .events .event-list .event-up-icon::before {
    content: "";
    position: absolute;
    width: 100%;
    top: 16px;
    left: 0;
    right: 0;
    border-bottom: 3px dashed #f6f6f6;
  }

  .hori-timeline .events .event-list .event-up-icon .up-arrow-icon {
    position: relative;
    background-color: #fff;
    padding: 4px;
  }
}

.verti-timeline {
  border-left: 3px dashed #f6f6f6;
  margin: 0 10px;
}

.verti-timeline .event-list {
  position: relative;
  padding: 0 0 40px 30px;
}

.verti-timeline .event-list .event-timeline-dot {
  position: absolute;
  left: -9px;
  top: 0;
  z-index: 9;
  font-size: 16px;
}

.verti-timeline .event-list .event-content {
  position: relative;
  border: 2px solid #eff2f7;
  border-radius: 7px;
}

.verti-timeline .event-list.active .event-timeline-dot {
  color: #556ee6;
}

.verti-timeline .event-list:last-child {
  padding-bottom: 0;
}

.plan-box .plan-btn {
  position: relative;
}

.plan-box .plan-btn::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background: #f6f6f6;
  left: 0;
  right: 0;
  top: 12px;
}
</style>
<!--====  End of INBOX  ====-->
